export const config = {
	menu: {
		offsetY: true
	},
	btn: {
		color: 'primary',
		depressed: true,
		outlined: true,
		ripple: true
	},
	icon: {
		class: 'ml-1'
	}
};
